import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import query from "@/Utils/request/query";
import { HttpMethod, Type } from "@/Utils/request/types";

interface Branding {
  name: string;
  tagline: string;
  logo: string;
  facility_id: string;
  kind: string;
}

const brandingApi = {
  path: "/api/v1/clinova/branding/",
  method: HttpMethod.GET,
  TRes: Type<Branding>(),
  noAuth: true,
} as const;

/**
 * Plan 32 F9: on a lab's own domain the login page shows the lab's name and
 * logo (nothing on Clinova's own address).
 */
export function LabBrand() {
  const { t } = useTranslation();
  const host = window.location.hostname;
  const { data } = useQuery({
    queryKey: ["clinova-branding", host],
    queryFn: query(brandingApi, { queryParams: { host }, silent: true }),
    retry: false,
    staleTime: Infinity,
  });
  useEffect(() => {
    if (data?.name) document.title = data.name;
  }, [data?.name]);
  if (!data) return null;
  return (
    <div
      className="mx-4 flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3"
      data-cy="lab-brand"
    >
      {data.logo && (
        <img src={data.logo} alt="" className="size-12 object-contain" />
      )}
      <div>
        <div className="text-lg font-semibold text-gray-900">{data.name}</div>
        <div className="text-xs text-gray-500">
          {data.tagline || t("lab_brand_powered")}
        </div>
      </div>
    </div>
  );
}
